import { useContext, useEffect, useState } from "react";
import UserContext from "../context/user-context";
import { useLocation } from "react-router-dom";
import { extractSearchParams } from "../helpers/JavascriptHelpers";
import { PlannerRecieverType } from "../types/Planner";

function useDecidePlanContacts() {
    const [data, setData] = useState<PlannerRecieverType | null>(null);

    const urlData = useLocation();

    const userContext = useContext(UserContext);
    const user = userContext?.user;

    useEffect(() => {
        if (user) {
            if (user.role === 2)
                setData({ 
                    receiverId: user.special.id.toString(), 
                    receiverRole: 2, 
                    senderId: user.special.id.toString(), 
                    senderRole: 2, 
                    submitOnChange: true 
                })
            else if (user.role === 1) {
                const studentIds = extractSearchParams()['selectedStudent'];
                if (studentIds)
                    setData({ 
                        receiverId: studentIds.replaceAll('%2C', ','), 
                        receiverRole: 2, 
                        senderId: user.special.id.toString(), 
                        senderRole: 1, 
                        submitOnChange: false 
                    })
                else 
                    setData({ 
                        receiverId: user.special.id.toString(), 
                        receiverRole: 1, 
                        senderId: user.special.id.toString(), 
                        senderRole: 1, 
                        submitOnChange: true 
                    })
            }
        }
    }, [user, urlData])

    return data;
}

export default useDecidePlanContacts;